const cancelMemberButton = document.getElementById("cancel-member-button");

if (cancelMemberButton) {
  cancelMemberButton.addEventListener("click", async () => {
    console.log("gogogo");
  });
}
